// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-list ion-label {
  cursor: pointer;
  text-transform: uppercase;
  font-weight: bold;
}

.vertical-menu-icon {
  margin: 9px 21px 9px 0;
  filter: brightness(0);
  --icon-height: 1em;
  --icon-width: 1em;
  font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu/sidemenu-tabs/sidemenu-tabs.component.scss"],"names":[],"mappings":"AACI;EACI,eAAA;EACA,yBAAA;EACA,iBAAA;AAAR;;AAGA;EACI,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAAJ","sourcesContent":["ion-list {\r\n    ion-label {\r\n        cursor: pointer;\r\n        text-transform: uppercase;\r\n        font-weight: bold;\r\n    }\r\n}\r\n.vertical-menu-icon {\r\n    margin: 9px 21px 9px 0;\r\n    filter: brightness(0);\r\n    --icon-height: 1em;\r\n    --icon-width: 1em;\r\n    font-size: 20px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
